import {TaskResponse} from './task-response';

export class SfrComplexityTaskResponse extends TaskResponse {

  sfrComplexity!: string;
  comments!: string;

}

